import { NumberInput as Number } from "./number/number-input";
import { TextInput as Text } from "./string/text-input";
import { DateInput as Date } from "./dates/date-input";
import { DatetimeInput as Datetime } from "./dates/datetime-input";
import { TimeInput as Time } from "./dates/time-input";
import { PhoneNumberInput as PhoneNumber } from "./string/phone-number-input";
import { EmailInput as Email } from "./string/email-input";
import { Dropdown, DropdownNumber, DropdownMulti } from "./dropdown/dropdown";
import { CheckboxInput as Checkbox } from "./checkbox/checkbox-input";
import { TextareaInput as Textarea } from "./string/textarea-input";

export const Input = {
  Number,
  Text,
  Date,
  Datetime,
  Time,
  Checkbox,
  PhoneNumber,
  Email,
  Dropdown,
  DropdownNumber,
  DropdownMulti,
  Textarea
};
